import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Form, Select, Spin } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  mapData,
  setFilteredFileCols,
} from "../../redux/actions/salesDataActions";
import { RootState } from "../../redux/rootReducer";
import { MasterRequiredColumn } from "../../shared/constant";

const getClasses = (displayMapping: Boolean) =>
  `grid ${
    displayMapping ? "grid-cols-2" : "grid-cols-3 gap-7"
  } min-h-[46px] items-center px-4`;

function MapData({ displayMapping }: { displayMapping?: Boolean }) {
  const dispatch = useDispatch();
  const { newFile, filteredFileCols, masterColumns } = useSelector(
    (state: RootState) => state.salesData,
  );

  /* TODO The dropdown value string should be unique. Otherwise the logic will overlap */
  const handleMappingChange = (item: string, index: number) => {
    // console.log("On Change: ", item, index, filteredFileCols);
    if (item) {
      const filteredOptions = filteredFileCols.map(
        (el: string, idx: number) => {
          if (el === item) return null;
          if (newFile.columns_list[idx] === masterColumns[index].rawColumn)
            return newFile.columns_list[idx];
          return el;
        },
      );
      // console.log("filteredOptions", filteredOptions);
      dispatch(setFilteredFileCols(filteredOptions));
    }
    dispatch(mapData(masterColumns, index, item));
  };

  const handleDeselect = (item: string) => {
    // console.log("onClear:", item);
    const filteredOptions = newFile.columns_list.map(
      (el: string, idx: number) => {
        if (item === el) return newFile.columns_list[idx];
        return filteredFileCols[idx];
      },
    );
    // console.log("filteredOptions", filteredOptions);
    dispatch(setFilteredFileCols(filteredOptions));
  };

  return (
    <div>
      <div
        className={`${getClasses(
          displayMapping as boolean,
        )} text-body1 bg-lotion resetborder-b border-light-silver`}
      >
        <div>Royalty Manager Columns</div>
        {!displayMapping && <div>Statement Columns</div>}
        <div>Status</div>
      </div>
      {!newFile && (
        <div className="h-[552px] text-center text-subheading16 pt-14">
          <div className="pb-4">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />}
            />
          </div>
          <div className="text-primary">RETRIEVING COLUMNS ..</div>
        </div>
      )}
      {newFile?.master_columns.map((item: string, idx: number) => (
        <div
          key={item}
          className={`${getClasses(displayMapping as boolean)} flash-border`}
        >
          <div
            className={`text-sm ${
              MasterRequiredColumn.includes(item) && "required-mark"
            }`}
          >
            {item}
          </div>
          {!displayMapping && (
            <div>
              <Form.Item
                name={item}
                rules={[{ required: MasterRequiredColumn.includes(item) }]}
                style={{ marginBottom: 0 }}
              >
                <Select
                  placeholder="Please select"
                  onDeselect={handleDeselect}
                  onChange={(el) => handleMappingChange(el, idx)}
                  className="w-full"
                  allowClear
                  showSearch
                >
                  {filteredFileCols.map(
                    (col: string) =>
                      col && (
                        <Select.Option key={col} value={col}>
                          {col}
                        </Select.Option>
                      ),
                  )}
                </Select>
              </Form.Item>
            </div>
          )}
          {masterColumns[idx].rawColumn ? (
            <div className="flex items-center gap-[9px] ">
              <CheckCircleOutlined className="text-success" />
              <div className={`${!displayMapping && "text-xs text-secondary"}`}>
                {displayMapping ? masterColumns[idx].rawColumn : "Mapped"}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-[9px] ">
              <InfoCircleOutlined className="text-warning" />
              <div className="text-xs text-secondary">Not mapped</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default MapData;
